export default __webpack_public_path__ + "static/11629-ffbd04f9fc25e14a32e8b455d2abc190.jpg";